import { CommonModule, formatDate } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbOffcanvasConfig, NgbOffcanvas, NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ClassroomService } from '../../../../core/services/classroom.service';
import { DayofWeekService } from '../../../../core/services/dayof-week.service';
import { ProfessorCourseService } from '../../../../core/services/professor-course.service';
import { ProgramService } from '../../../../core/services/program.service';
import { AppActionCheck } from '../../../../core/utils/app-action-check';
import { AppErrorShow } from '../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../core/utils/app-sweet-alert';
import { LocalStorageService } from '../../../../core/utils/local-stoarge-service';
import { SampleSearchPipe } from '../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../components/loading/loading.component';
import { HeaderComponent } from '../../layout/includes/header/header.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { SimpleCalendarComponent } from '../../../components/simple-calendar/simple-calendar.component';

@Component({
    selector: 'app-timetable',
    templateUrl: './timetable.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule, SimpleCalendarComponent],
    styleUrls: ['./timetable.component.css']
})
export class TimetableComponent {
  classroomSelected=null
  buttonsPermission :any|undefined;
 search_text=""
 subcourses:any[] =[]
  data:any[] =[]
  paccs:any[] =[]
  dows:any[] =[]
  classrooms:any[]=[]
  courses:any[]=[]
  calendars:any[] =[]
  selected_data:any;
  is_valid=null
  loading=false
  paccId=false
  classroomId=false
  openAdvanced=false
  dow_id:any
  minDate=new Date('dd-MM-yyyyT06:00')
  maxDate=new Date('dd-MM-yyyyT30:00')
  pg={
    pageSize:10,
    p:0,
    total:0
  }
  tag="admin-timetable"
  viewer=1;

  constructor(
    private dowService:DayofWeekService,
    private paccService:ProfessorCourseService,
    private router:Router,
    private classroomService:ClassroomService,
    private programService:ProgramService,
    private activatedRoute:ActivatedRoute,
    private _sanitizationService: DomSanitizer,
    configOffCanvas: NgbOffcanvasConfig,
     private offcanvasService: NgbOffcanvas,
     private toastrService: ToastrService,
     private spinnerService:NgxSpinnerService,
     private lsService:LocalStorageService,
     config: NgbModalConfig,
    private modalService: NgbModal) {
      config.backdrop = 'static';
      config.keyboard = false;
      
    configOffCanvas.position = 'end';
		configOffCanvas.backdropClass = 'bg-dark';
		configOffCanvas.keyboard = false;
   }
  ngOnInit(): void {
    // Les droits etaient figes en dur : la page ne tenait aucun compte du role.
    this.buttonsPermission={
      show:AppActionCheck.check(this.tag,'show'),
      add:AppActionCheck.check(this.tag,'add'),
      edit:AppActionCheck.check(this.tag,'edit'),
      delete:AppActionCheck.check(this.tag,'delete'),
      status:AppActionCheck.check(this.tag,'status'),
    }
   this.getDows()
   this.getClassrooms()
  }

  getClassrooms(){
    this.classroomService.getAll().subscribe((res:any)=>{
      this.classrooms=res.data
      this.modalService.dismissAll()
    },
    (err:any)=>{
AppErrorShow.showError("Emploi du temps",err)
    })
  }
  getDows(){

    this.dowService.getDows().subscribe((res:any)=>{
      this.dows=res.data
      },
  (err:any)=>{
    AppErrorShow.showError("Emploi du temps",err)

  })
  }

  
  getAll(){
    this.spinnerService.show()
    this.programService.getAll(this.classroomSelected).subscribe((res:any)=>{
      this.data=res.data
      this.modalService.dismissAll()
      this.spinnerService.hide()

    },
    (err:any)=>{
      this.spinnerService.hide()

AppErrorShow.showError("Emploi du temps",err)
    })
  }

  getPrograms(day_number:any){
    let check= this.data.find((el:any)=>el.day_number == day_number);
    return check!=null ?check?.programs : []
  }

  getPaccs(){
    this.courses=[]
    this.paccService.getAll(this.classroomSelected).subscribe((res:any)=>{
      this.paccs=res.data
      res.data.forEach((element:any) => {
        element.courses.forEach((element2:any) => {
          element2['professor']=`${element.professor?.lastname} ${element.professor?.firstname}` 
          this.courses.push(element2)
        });
      });
      },
  (err:any)=>{
    AppErrorShow.showError("Emploi du temps",err)

  })
  }

  loadPacs(ev:any){
    this.classroomId=ev.target.value
    this.classroomSelected=ev.target.value
    this.getAll()
    this.getPaccs()
    this.getForCalendar()
  }

  getForCalendar(){
    this.calendars=[]
    this.spinnerService.show()
    this.programService.getProfessorCurrentWeekPrograms(this.classroomId).subscribe((res:any)=>{
      this.calendars=res.data
      //this.spinnerService.hide()
      this.spinnerService.hide()

    },
    (err:any)=>{
      this.spinnerService.hide()

      AppErrorShow.showError("Emploi du temps",err)

    })
}

  loadCourses(ev:any){
    this.courses=this.paccs.find((el:any)=>el.id == ev.target.value).courses
  }
  setPaccId(ev:any){
    this.paccId=this.courses.find((el:any)=>el.id == ev.target.value).pivot.id
    this.subcourses=this.courses.find((el:any)=>el.id == ev.target.value).subcourses
  }

  filterPrograms(element: any) {
    return element.programs
  }
  
  checked(el?:any){
    this.selected_data=el;
    this.is_valid=el.is_valid
  }
  verifyIfElementChecked(){
    if (this.selected_data==null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }
  
    show(){
    if(!this.verifyIfElementChecked()) return ;
    this.router.navigate(['/admin/inscription-details/'+this.selected_data.code])
  }


  delete(id:any){
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.programService.delete(id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        // La vue calendrier restait sur des donnees perimees apres suppression.
        this.getAll()
        if (this.viewer==2) this.getForCalendar()
    },
    (err:any)=>{
        AppErrorShow.showError("Emploi du temps",err)

    })
  }
})
  }

  setStatus(value:any){

    this.toastrService.warning("Opération en cours")
  
        this.paccService.setState(this.selected_data.code,value).subscribe((res:any)=>{
          this.toastrService.success(res.message)
          this.getAll()
      },
      (err:any)=>{
          AppErrorShow.showError("Emploi du temps",err)

      })
  }

  
  add(content:any, id:any){
    this.dow_id=id
    this.modalService.open(content,{size:'lg'});
  }
  edit(content:any, el:any){
    this.selected_data=el
    this.openAdvanced=this.selected_data.sub_course_id?true:false
    this.paccId=this.courses.find((el:any)=>el.id == this.selected_data.pacc.course.id).pivot.id
    this.subcourses=this.courses.find((el:any)=>el.id == this.selected_data.pacc.course.id).subcourses
    this.modalService.open(content,{size:'lg'});
  }
  store(value:any){

    // let d1 =formatDate(new Date(value.start_time),'hh:mm:ss','en_US');
    // let d2 =formatDate(new Date(value.end_time),'hh:mm:ss','en_US');
 
    //  if(d2 < d1){
 
    //    this.toastrService.error(`L'heure de fin ne peut pas être antérieure à l'heure de début`)
    //    return ;
    //  }


     
    this.loading=true

    
    this.programService.store({
      start_time:value.start_time,
      end_time:value.end_time,
      pacc_id:this.paccId,
      dow_id:this.dow_id,
      authorize:value.authorize,
      classroom_id:this.classroomId,
      sub_course_id:value.sub_course_id,
      name:value.name
    }).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.getAll()

    },
    (err:any)=>{
      this.loading=false

        AppErrorShow.showError("Emploi du temps",err)

    })
  }
  store2(value:any){

    // let d1 =formatDate(new Date(value.start_time),'hh:mm:ss','en_US');
    // let d2 =formatDate(new Date(value.end_time),'hh:mm:ss','en_US');
 
    //  if(d2 < d1){
 
    //    this.toastrService.error(`L'heure de fin ne peut pas être antérieure à l'heure de début`)
    //    return ;
    //  }


     
    this.loading=true

    
    this.programService.store({
      start_time:value.start_time,
      end_time:value.end_time,
      pacc_id:null,
      dow_id:this.dow_id,
      authorize:true,
      classroom_id:this.classroomId,
      sub_course_id:null,
      name:value.name
    }).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.getAll()

    },
    (err:any)=>{
      this.loading=false

        AppErrorShow.showError("Emploi du temps",err)

    })
  }
  update(value:any){
    this.loading=true

    
    this.programService.update(
      this.selected_data.id,
      {
      start_time:value.start_time,
      end_time:value.end_time,
      pacc_id:this.paccId,
      sub_course_id:value.sub_course_id,
      name:value.name
    }).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.getAll()

    },
    (err:any)=>{
      this.loading=false

        AppErrorShow.showError("Emploi du temps",err)

    })
  }


  reload(ind:any){
    this.viewer=ind;

    if(ind==2)this.getForCalendar()
  }


}
